// 진입 카드 띠에 전광판처럼 돌아가는 고객 질문 예시 — 이름 대신 A·B·C 고객으로 표기한다
const QUESTIONS = [
  { who: 'A고객', text: '물품은 알겠는데 어떤 차량에 괜찮을까요?' },
  { who: 'B고객', text: '모니터 3박스예요. 오토바이로도 갈 수 있나요?' },
  { who: 'C고객', text: '깨지기 쉬운 물건인데 포장은 어떻게 하죠?' },
  { who: 'D고객', text: '파렛트 2개면 1톤 트럭으로 충분한가요?' },
  { who: 'E고객', text: '냉장 식품은 어떤 차량이 안전할까요?' },
  { who: 'F고객', text: '사진만 보내도 차량을 골라 주나요?' },
];

export default QUESTIONS;
